import { render } from "./TheWrapperPrivate.vue?vue&type=template&id=337ae690&scoped=true"
import script from "./TheWrapperPrivate.vue?vue&type=script&lang=js"
export * from "./TheWrapperPrivate.vue?vue&type=script&lang=js"

import "./TheWrapperPrivate.vue?vue&type=style&index=0&id=337ae690&lang=scss"
import "./TheWrapperPrivate.vue?vue&type=style&index=1&id=337ae690&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337ae690"]])

export default __exports__